const estadosFederativosOptions = [
  { value: 1, label: "Aguascalientes" },
  { value: 2, label: "Baja California" },
  { value: 3, label: "Baja California Sur" },
  { value: 4, label: "Campeche" },
  { value: 5, label: "Chiapas" },
  { value: 6, label: "Chihuahua" },
  { value: 7, label: "Coahuila" },
  { value: 8, label: "Colima" },
  { value: 9, label: "Distrito Federal" },
  { value: 10, label: "Durango" },
  { value: 11, label: "Guerrero" },
  { value: 12, label: "Guanajuato" },
  { value: 13, label: "Hidalgo" },
  { value: 14, label: "Jalisco" },
  { value: 15, label: "México" },
  { value: 16, label: "Michoacán" },
  { value: 17, label: "Morelos" },
  { value: 18, label: "Nayarit" },
  { value: 19, label: "Nuevo León" },
  { value: 20, label: "Oaxaca" },
  { value: 21, label: "Puebla" },
  { value: 22, label: "Querétaro" },
  { value: 23, label: "Quintana Roo" },
  { value: 24, label: "San Luis Potosí" },
  { value: 25, label: "Sinaloa" },
  { value: 26, label: "Sonora" },
  { value: 27, label: "Tabasco" },
  { value: 28, label: "Tamaulipas" },
  { value: 29, label: "Tlaxcala" },
  { value: 30, label: "Veracruz" },
  { value: 31, label: "Yucatán" },
  { value: 32, label: "Zacatecas" },
  { value: 33, label: "Otro" },
]

const GetOptionsEstadosFederativosFn = (elige = true) => {
  let Options = estadosFederativosOptions

  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige ...", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return Options
}

export { estadosFederativosOptions, GetOptionsEstadosFederativosFn }
